<template>
  <v-snackbar
    v-model="myAlert.visible"
    :color="myAlert.color"
    :multi-line="myAlert.mode === 'multi-line'"
    :timeout="myAlert.timeout"
    :vertical="myAlert.mode === 'vertical'"
    v-if="myAlert.visible"
  >
    {{ alert.text }}
    <v-btn dark text @click="myAlert.visible = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AppAlert",
  data() {
    return {
      myAlert: {
        visible: false,
        color: "#EEFFEE",
        timeout: 2000,
        mode: "vertical"
      }
    };
  },
  computed: {
    ...mapState({
      alert: "appAlert"
    })
  },
  mounted: function() {},
  methods: {},
  watch: {
    alert: function(val) {
      this.myAlert = val;
    }
  }
};
</script>
